module.exports = __webpack_public_path__ + "static/media/money3.cbea4e44.png";